import { render, staticRenderFns } from "./PlpProduct.vue?vue&type=template&id=4b51e1a8&scoped=true&"
import script from "./PlpProduct.vue?vue&type=script&lang=js&"
export * from "./PlpProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51e1a8",
  null
  
)

export default component.exports